// mantine
import { UnstyledButton } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { useClipboard } from '@mantine/hooks';
// utils
import { IAct } from '@newo/api/gateway';

interface EventDetailsProps {
    act: IAct;
}

const EventDetails = ({ act }: EventDetailsProps) => {
    const clipboard = useClipboard({ timeout: 0 });
    const handleCopy = (value: string) => {
        clipboard.copy(value);
        notifications.show({
            color: 'blue',
            message: 'Copied to clipboard',
            autoClose: 3000
        });
    };
    return (
        <>
            <div className="flex flex-col gap-0.5 text-xs">
                <div className="flex gap-2">
                    <span>User persona name:</span>
                    <span className="text-gray-6">{act.user_persona_name}</span>
                </div>

                {act.runtime_context_id ? (
                    <div className="flex gap-2">
                        <span>Runtime Context Id</span>
                        <span className="text-gray-6">
                            {act.runtime_context_id}
                        </span>
                    </div>
                ) : undefined}
                <div className="flex gap-2">
                    <span>External Event Id:</span>
                    <span className="text-gray-6">{act.external_event_id}</span>
                </div>

                <div className="flex gap-2">
                    <span>Integration Idn:</span>
                    <span className="text-gray-6">{act.integration_idn}</span>
                </div>

                <div className="flex gap-2">
                    <span>Reference Idn:</span>
                    <span className="text-gray-6">{act.reference_idn}</span>
                </div>

                <div className="flex gap-2">
                    <span>Connector Idn:</span>
                    <span className="text-gray-6">{act.connector_idn}</span>
                </div>

                <div className="flex gap-2">
                    <span>External Id:</span>
                    <span className="text-gray-6">{act.external_id}</span>
                </div>
            </div>
            {act.arguments.length > 0 && (
                <div className="text-sm font-semibold mt-4 col-span-2">
                    Arguments
                </div>
            )}
            <div className="text-xs pl-4 flex flex-col gap-0.5">
                {act.arguments.map(({ name, value }) => (
                    <div className="flex gap-2" key={name}>
                        <span>{name}:</span>
                        <UnstyledButton
                            className="text-xs text-gray-6 hover:text-gray-7 break-all"
                            onClick={() => {
                                handleCopy(value);
                            }}
                        >
                            {value}
                        </UnstyledButton>
                    </div>
                ))}
            </div>
        </>
    );
};

export default EventDetails;
